import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const ArtDetailsContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LeftContent = styled.div`
  display: flex;
  gap: 8px;
`;

export const ArtName = styled.p`
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.neutrals.b};
`;

export const NumberOfArt = styled.p`
  ${({ theme }) => css(theme.typographys.tiny.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`;

export const Price = styled.p`
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.neutrals.b};
`;

export const ImageContent = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color:  ${({ theme }) => theme.colors.grey[1]};
`;
